/**
 * Check if all positions are nearly equal to each other
 * @param positions - The positions to check
 * @param epsilon - The epsilon value
 * @returns True if all positions are nearly equal, false otherwise
 */
const areAllInSamePosition = (
  positions: google.maps.LatLngLiteral[],
  epsilon = 0.00005 // ~5 meters
) => {
  return positions.every(
    position =>
      isNearlyEqual(position.lat, positions[0].lat, epsilon) &&
      isNearlyEqual(position.lng, positions[0].lng, epsilon)
  )
}

const isNearlyEqual = (a: number, b: number, epsilon: number) =>
  Math.abs(a - b) < epsilon

export { areAllInSamePosition }
